import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';
import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import { Vendor_UNASSIGNED, Vendor_UNASSIGNED_ERROR, Vendor_UNASSIGNED_SUCCESS } from '../../../../actionType.js';
import apiCall from '../../../../apiCall.js';

function* vendorUnAssigned({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { version } = payload;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/${version}/reset-vendor`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: {
        ...payload?.body,
      },
    });

    if (response.status === 200) {
      if (response?.data?.code == 4089) cogoToast.warn(response?.data?.message);
      else cogoToast.success('Vendor unassigned successfully!');
      yield put({
        type: Vendor_UNASSIGNED_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: Vendor_UNASSIGNED_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: Vendor_UNASSIGNED_ERROR, payload: error });
  }
}

export function* watchVendorUnAssigned() {
  yield takeEvery(Vendor_UNASSIGNED, vendorUnAssigned);
}

function* vendorUnAssignedSaga() {
  yield all([fork(watchVendorUnAssigned)]);
}

export default vendorUnAssignedSaga;
